import React, { useRef } from "react";
import { Container } from "reactstrap";
import { Baner } from "agronomist-ui-components";
import "./Section.scss";
import { SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import Section from "./Section";
import { CarouselWrapper } from "./CarouselWrapper";

const BannersCarousel = ({
  title,
  subtitle,
  className,
  // isCarousel = true,
  articles,
  background = "light", // "light" | "dark"
  slidesPerView,
}) => {
  const { t } = useTranslation(["widgets"]);
  // const sliderOn = isCarousel || window.innerWidth < 1200;
  const lang = Cookies.get("user_lang");
  const swiper = useRef(null);

  return (
    <div className={`Sections--${background} banners-carousel`}>
      <Container>
        <Section
          className={`
            ${className || ""}
          `}
          title={title && <h2>{title}</h2>}
          subtitle={subtitle}
        >
          <CarouselWrapper
            slidesPerViewMed={4}
            slidesPerViewBig={slidesPerView || 4}
            swiperRef={swiper}
            showNav={articles.length > 4 || window.innerWidth < 1200}
            showPag={articles.length > 4 || window.innerWidth < 1200}
          >
            {articles
              .filter(banner => {
                // Hiding nowy polski pomidor banner for gb lang #AG-1244
                if (lang === "gb") {
                  return banner.to !== "/nowy-polski-pomidor";
                }
                return banner;
              })
              .map(el => {
                return (
                  <SwiperSlide key={`slide-${el.title}`}>
                    <Baner
                      key={el.title}
                      id={el.title}
                      title={t(el.title)}
                      description={t(el.desc)}
                      coverUrl={el.cover !== null ? el.cover : ""}
                      label={t(el.cta)}
                      url={el.to}
                    />
                  </SwiperSlide>
                );
              })}
          </CarouselWrapper>
        </Section>
      </Container>
    </div>
  );
};

export default BannersCarousel;
